import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { ThirdParty } from '../entity/third-party';
import { Order } from '../entity/order';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CustomerInfosService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  getAgreementByProducerId(producerId: string) {
        return this.http.get(environment.apiUrl + 'site-api/list/defaultAgreement?producerId=' + producerId,  {headers: this.headers})
        .map(res => {
          return res.json();
        })
        .catch(this.handleError);
    }

  public editCustomerInfos(thirdParty: ThirdParty) {
      return this.http.post(environment.apiUrl + 'site-api/customer-infos/edit', JSON.stringify({thirdParty: thirdParty}), {headers: this.headers})
             .toPromise()
             .then(
                function(response) {
                  let response_obj = response.json();
                  return response_obj;
                }
              )
             .catch(this.handleError);
  }

  public getCustomerInfosOrders(criteria): Promise<any> {
    return this.http.post(environment.apiUrl + 'site-api/customer-infos/list', JSON.stringify(criteria), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let orders = [];
                    let response_obj = response.json();
                    let lastComment = response_obj['lastComment'];
                    let allComments = response_obj['allComments'];
                    let allOrders =  response_obj['orders'];
                    const counts = response_obj['counts'];
                      for(let index in allOrders){
                          let order = new Order();
                          order.fromJSON(response_obj['orders'][index]);
                          orders[orders.length] = order;
                      }
                    return {
                      'orders': orders,
                      'counts': counts,
                      'lastComment': lastComment,
                      'allComments': allComments
                    };
                  }
                )
                .catch(this.handleError);
  }

  public getAgreements(): Observable<any> {
      return this.http.get(environment.apiUrl + 'site-api/list/agreements', {headers: this.headers});
  }

  public getProductionKinds(): Observable<any> {
      return this.http.get(environment.apiUrl + 'site-api/list/production_kinds',  {headers: this.headers});
  }

  public getMappingBetweenProductionKindAndAgreement(): Observable<any> {
      return this.http.get(environment.apiUrl + 'site-api/list/production_kinds_agreements_mapping', {headers: this.headers});
  }

  public getLastTurnByProducerSiret(producerSiret: string) {
      return this.http.post(
          environment.apiUrl + 'site-api/customer-infos/get_last_sample_turn_by_producer',
          JSON.stringify({producerSiret: producerSiret}),
          {headers: this.headers}
      ).map(res => {
          return res.json();
      });
  }

  public getDefaultRelations(producerSiret: string) {
      return this.http.post(
          environment.apiUrl + 'site-api/customer-infos/get_default_relations_by_producer',
          JSON.stringify({producerSiret: producerSiret}),
          {headers: this.headers}
      ).map(res => {
          return res.json();
      });
  }

  public orderCustomerInfosModification(data): Promise<any> {
    return this.http.post(environment.apiUrl + 'site-api/customer-infos/order', JSON.stringify(data), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    let orderCode = response_obj['orderCode'];
                    return orderCode;
                  }
                )
               .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

    postCancelOrder(data): Promise<any> {
        return this.http.post(environment.apiUrl + '/site-api/cancel-order', JSON.stringify(data), {headers: this.headers})
            .toPromise()
            .then(
                function (response) {
                    return response.json();
                }
            )
            .catch(this.handleError);
    }

    getOrderComments(orderNumber: string) {
        return this.http.get(environment.apiUrl + '/site-api/get-order-comments?orderNumber=' + orderNumber, {headers: this.headers})
            .toPromise()
            .then(
                function (response) {
                    let response_obj = response.json();
                    let allComments = response_obj['allComments'];
                    return allComments;
                }
            )
            .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// ./src/app/customer-infos/customer-infos.service.ts